/**
 * 境界ボックスを canvas 外に配置する距離（px）
 * PhysicsEngine の物理ボディと gameEngineBoundary の描画で共有する。
 */
export const BOUNDARY_DISTANCE = 400;
